import { QUOTE_PROGRESS, QUOTE_STATUS } from '@/types/sales';

export const QUOTES_PAGE_SIZE = 60;
export const QUOTES_STALE_TIME = 30000; // 30 seconds
export const QUOTES_GC_TIME = 5 * 60 * 1000; // 5 minutes

export const QUOTES_QUERY_OPTIONS = {
  staleTime: QUOTES_STALE_TIME,
  gcTime: QUOTES_GC_TIME,
};

export const QUOTES_QUERY_KEY = 'quotes';
export const QUOTE_QUERY_KEY = 'quote';

/**
 * Quote status labels mapping
 * Maps quote status enum values to their display labels
 */
export const QUOTE_STATUS_LABELS: Record<QUOTE_STATUS, string> = {
  [QUOTE_STATUS.ACCEPTED]: 'ACCEPTED',
  [QUOTE_STATUS.AWAITING_ACCEPTANCE]: 'AWAITING ACCEPTANCE',
  [QUOTE_STATUS.DECLINED]: 'DECLINED',
};

/**
 * Quote progress labels mapping
 * Maps quote progress enum values to their display labels
 */
export const QUOTE_PROGRESS_LABELS: Record<QUOTE_PROGRESS, string> = {
  [QUOTE_PROGRESS.ACTIVE]: 'ACTIVE',
  [QUOTE_PROGRESS.PENDING]: 'PENDING',
};

/**
 * Quote status colors mapping
 * Maps quote status enum values to their color classes
 */
export const QUOTE_STATUS_COLORS: Record<QUOTE_STATUS, string> = {
  [QUOTE_STATUS.ACCEPTED]: 'bg-blue-500 !text-blue-500',
  [QUOTE_STATUS.AWAITING_ACCEPTANCE]: 'bg-yellow-500 !text-yellow-500',
  [QUOTE_STATUS.DECLINED]: 'bg-red-500 !text-red-500',
};

/**
 * Quote status categories for grouping
 */
export const QUOTE_STATUS_CATEGORIES = {
  PENDING: [QUOTE_STATUS.AWAITING_ACCEPTANCE],
  ACTIVE: [QUOTE_PROGRESS.ACTIVE],
  ACCEPTED: [QUOTE_STATUS.ACCEPTED],
  CANCELLED: [QUOTE_STATUS.DECLINED],
} as const;

/**
 * Quote status category colors with opacity
 */
export const QUOTE_STATUS_CATEGORY_COLORS = {
  PENDING: {
    bg: 'bg-yellow-400',
    text: '!text-yellow-400',
    textBadge: '!text-yellow-400',
    bgBadge: '!bg-yellow-400/10',
  },
  ACTIVE: {
    bg: 'bg-green-400',
    text: '!text-green-400',
    textBadge: '!text-teal-400',
    bgBadge: '!bg-teal-400/10',
  },
  CANCELLED: {
    bg: 'bg-red-400',
    text: '!text-red-400',
    textBadge: '!text-red-400',
    bgBadge: '!bg-red-400/10',
  },
  ACCEPTED: {
    bg: 'bg-blue-400',
    text: '!text-blue-400',
    textBadge: '!text-blue-400',
    bgBadge: '!bg-blue-400/10',
  },
} as const;
